// extracted by mini-css-extract-plugin
export var optionGrid = "_63-7";
export var optionList = "_63-6";
export var questionsBlock = "_63-9";
export var spacer = "_63-5";
export var stepCenteredContent = "_63-3";
export var stepInner = "_63-0";
export var stepInnerFullWidth = "_63-1";
export var stepInnerLockScroll = "_63-2";
export var stepTransitionFrame = "_63-4";
export var welcomeBlock = "_63-8";